import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  OnChanges,
  inject
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

import { Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/base/api-constants';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { UtilService } from 'src/app/services/util.service';
import {
  deleteError,
  deleteIndex,
  deleteSuccess,
  saveIndex,
  setAllIndices,
  setError,
  setIndex
} from 'src/app/STORE/actions/indexdesigner.actions';
import {
  deleteFailure,
  deletedSuccess,
  saveFailure,
  saveSuccess
} from 'src/app/STORE/selectors/indexdesigner.selector';
import { tableFieldsForDM } from 'src/app/STORE/selectors/services.selector';
import { v4 as uuidv4 } from 'uuid';
import { ReferenceUtilService } from '../reference-tree-view/reference-util.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { FsBaseService } from 'src/app/services/fs-base.service';
import { runtimeWorkflowStatusField } from 'src/app/STORE/selectors/applicationdatamodel.selector';
import { ActionType, ModelType, UiActions } from '../reference-tree-view/reference.enum';
import { DialogService } from 'primeng/dynamicdialog';
export enum IndexType {
  PRIMARY = 'PRIMARY',
  KEY = 'SECONDARY',
  UNIQUE = 'UNIQUE'
}
@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-index-designer',
  templateUrl: './index-designer.component.html',
  styleUrls: ['./index-designer.component.scss'],
  providers: [DialogService],
  standalone: false //NOSONAR
})
export class IndexDesignerComponent implements OnInit, OnChanges, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private zone = inject(NgZone);
  private util = inject(UtilService);
  private appGlobalService = inject(AppGlobalService);
  private store = inject(Store);
  private translate = inject(TranslateService);
  private referenceUtil = inject(ReferenceUtilService);
  private fsService = inject(FsBaseService);
  private bs = inject(HttpBaseService);

  indices: any = [];
  selectedIndex;
  loader = false;
  showDesigner = false;
  svgPaths = GlobalConstants.svgPaths;
  @Input() formData: any = null;
  @Input() tableIdMap: any = null;
  @Input() fieldIdMap: any = null;
  @Input() pickList: any = null;
  @Input() disableField = false;
  @Input() formFields: any = null;
  @Input() showTable = true;
  @Input() showDetail = false;
  submitted = false;
  subscriptions: Subscription[] = [];
  fieldInfos: any;
  isLoading = false;
  transientSids: any[] = [];
  tableName = '';
  typeOptions = [
    {
      label: 'Primary',
      value: IndexType.PRIMARY
    },
    {
      label: 'Secondary',
      value: IndexType.KEY
    },
    {
      label: 'Unique',
      value: IndexType.UNIQUE
    }
  ];
  fieldProperty: any = {
    lookupTo: 'indexFields',
    name: 'fields'
  };
  indexFormData: any;
  hasReference = false;
  indexObj: any;
  formGroup: FormGroup = new FormGroup({
    indexName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z]+[a-zA-Z0-9_]*[a-zA-Z0-9]*$')]),
    indexType: new FormControl('', [Validators.required]),
    fields: new FormControl('', [Validators.required])
  });
  allFields: any = [];
  datatypeSize = {
    string: 1020,
    number: 8,
    dropdown: 1020,
    datetime: 42,
    boolean: 1,
    text: 1020,
    checkbox: 1,
    currency: 10,
    date: 3,
    double: 8,
    email: 1020,
    radio: 1020,
    url: 1020,
    'yes no': 1020,
    color: 1020,
    'auto-number': 8
  };
  appId = '';
  orgId = '';

  get isBetaAccessPrivilegeConsumable(): boolean {
    return this.appGlobalService.betaAccessPrivilegeForApp;
  }

  disallowEdit = false;
  modifiedTypeOptions: any;
  isSidFieldAvlInIndex = false;
  isSidUniqueIndex = false;
  initialCall: boolean = true;
  @Output() public readonly saveIndexEvent = new EventEmitter();
  rwfStatusField: any;
  fsDataSub: any;

  ngOnDestroy(): void {
    // For auto unsubscribe
    this.store.dispatch(setIndex({ savedIndex: null }));
    this.store.dispatch(setError({ error: null }));
    this.store.dispatch(deleteSuccess({ deleteIndexId: null }));
    this.store.dispatch(deleteError({ deleteError: null }));
    this.unsubscribeListener();
  }

  ngOnChanges(): void {
    if (this.showDetail && !this.showTable) {
      this.openIndexDesigner();
      if (!this.pickList) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    }
  }

  ngOnInit(): void {
    this.tableName = this.formData.name;
    this.appId = this.appGlobalService.get('appId');
    this.orgId = this.appGlobalService.get('orgId');
    this.modifiedTypeOptions = this.typeOptions;
    this.getFieldsInTable(this.formData.sid);

    this.store.select(saveFailure).subscribe((err: any) => {
      if (err) {
        this.isLoading = false;
      }
    });
    let fldSub = this.store.select(tableFieldsForDM).subscribe((res: any) => {
      if (res) {
        if (res.length > 0) {
          this.allFields = res;
          for (let i = 0; i < res.length; i++) {
            if (res[i].f_transientField) {
              this.transientSids.push(res[i].sid);
            }
          }
        }
      }
    });
    this.subscriptions.push(fldSub);
    let saveSuccessSub = this.store.select(saveSuccess).subscribe((index: any) => {
      if (index) {
        this.onCloseDesigner();
        this.saveIndexEvent.emit(index);
      }
    });
    this.subscriptions.push(saveSuccessSub);
    const saveFailureSub = this.store.select(saveFailure).subscribe((err: any) => {
      if (err) {
        this.isLoading = false;
        this.util.showErrMsg({
          apiErr: err,
          tableMap: this.tableIdMap,
          fieldMap: this.fieldIdMap,
          admData: this.formData
        });
      }
    });
    this.subscriptions.push(saveFailureSub);
    const deleteSuccessSelect = this.store.select(deletedSuccess).subscribe((indexId: any) => {
      if (indexId) {
        this.isLoading = false;
        this.indices = this.indices.filter((idx) => idx.sid !== indexId);
      }
    });
    this.subscriptions.push(deleteSuccessSelect);

    const deleteFailureSelect = this.store.select(deleteFailure).subscribe((err: any) => {
      if (err) {
        this.isLoading = false;
      }
    });
    this.subscriptions.push(deleteFailureSelect);

    const runtimeWorkflowStatusFieldSub = this.store.select(runtimeWorkflowStatusField).subscribe((res: any) => {
      if (res) {
        this.rwfStatusField = res;
      }
    });
    this.subscriptions.push(runtimeWorkflowStatusFieldSub);
    this.getDataFromFS();
  }

  openIndexDesigner(id?, column?) {
    this.formGroup.reset();
    this.indexFormData = null;
    this.submitted = false;
    this.isSidUniqueIndex = false;
    if (id) {
      let data = this.indices.find((e) => e.sid === id);
      this.errorObj = {
        type: '',
        errorMsg: ''
      };
      this.validateFieldsUsedInIndex(data);
      if (data.childTables && data.childTables.length > 0) {
        this.util.showInfo(this.translate.instant("Index used in Foreign Key and can't edit"));
        return;
      }
      const flds = data.fields.join(',');
      data = { ...data, ...{ fields: flds } };
      this.indexFormData = data;
      this.formGroup.patchValue(this.indexFormData);
      this.isSidUniqueIndex = this.isSystemSidIndex(data);
    }
    const isSidFieldAvl = this.getFieldNames(column?.fields).includes('Sid');
    if (isSidFieldAvl) {
      this.isSidFieldAvlInIndex = true;
      this.modifiedTypeOptions = this.typeOptions.filter((obj) => obj.value !== IndexType.KEY);
      this.disallowEdit = true;
    } else {
      this.isSidFieldAvlInIndex = false;
      this.disallowEdit = false;
      this.modifiedTypeOptions = this.typeOptions;
    }
    this.showDesigner = true;
  }

  errorObj = {
    type: '',
    errorMsg: ''
  };
  validateFieldsUsedInIndex(index: any) {
    const fields = index.fields.join(',');
    const fieldArray = fields.split(',').map((f) => f.trim());
    const invalidFields = fieldArray.filter((f) => !this.allFields.some((fieldObj) => fieldObj.sid === f));
    const invalidFieldType = fieldArray.filter((f) =>
      this.allFields.some(
        (fieldObj) =>
          fieldObj.sid === f && (fieldObj.f_type === 'Image Carousel' || fieldObj.f_type === 'File Attachments')
      )
    );
    if (invalidFields.length > 0) {
      this.util.handleDeletedIds(invalidFields, false, '', false, '', (message) => {
        this.errorObj.type = 'error';
        this.errorObj.errorMsg = this.translate.instant('INDEX_FIELD_DELETED').replace('{field}', message);
      });
    } else if (invalidFieldType.length > 0) {
      this.util.handleDeletedIds(invalidFieldType, false, '', false, '', (message) => {
        this.errorObj.type = 'warning';
        this.errorObj.errorMsg = this.translate.instant('INDEX_FIELD_TYPE_CHANGED').replace('{field}', message);
      });
    } else {
      this.errorObj = {
        type: '',
        errorMsg: ''
      };
    }
  }
  fields: any[] = [];
  getFieldsInTable(tableId: string) {
    const params = { tableId: tableId };
    this.bs['get'](ApiConstants.getFieldInfo, params).subscribe({
      next: (res: any) => {
        this.fields = res;
      },
      error: (error: any) => {
        console.error('Error fetching fields:', error);
      }
    });
  }

  isSystemSidIndex(index: any): boolean {
    if (!index) {
      return false;
    }
    const indexName = (index.indexName || '').toString().trim().toLowerCase();
    if (indexName === 'sidunique') {
      return true;
    }
    const fields = Array.isArray(index.fields)
      ? index.fields
      : (index.fields || '')
          .toString()
          .split(',')
          .map((f) => f.trim())
          .filter((f) => !!f);
    const isSidField = fields.length === 1 && this.fieldIdMap?.[fields[0]] === 'Sid';
    const isUniqueOrPrimary = index.indexType === IndexType.UNIQUE || index.indexType === IndexType.PRIMARY;
    return isSidField && isUniqueOrPrimary;
  }

  onCloseDesigner(hideOnly?: any) {
    this.errorObj = {
      type: '',
      errorMsg: ''
    };
    this.showDesigner = false;
    this.showDetail = false;
    this.indexFormData = null;
    this.submitted = false;
    this.isLoading = false;
    this.isSidUniqueIndex = false;
    if (hideOnly) {
      this.saveIndexEvent.emit(null);
    }
  }
  trimName(name: any) {
    const title = name.trim().replace(/\s\s+/g, ' ');
    const fieldName = title.toLowerCase();
    return fieldName;
  }

  private normalizeIndexName(raw: string): string {
    return (raw || '').trim().replace(/\s\s+/g, ' ');
  }

  private normalizeFieldIds(raw: string | string[]): string[] {
    let arr: string[] = Array.isArray(raw)
      ? raw
      : (raw || '')
          .toString()
          .split(',')
          .map((f) => f.trim())
          .filter((f) => !!f);
    const seen = new Set<string>();
    arr = arr.filter((f) => (seen.has(f) ? false : (seen.add(f), true)));
    return arr;
  }

  private calcIndexLength(fieldIds: string[]): number {
    let total = 0;
    for (const fid of fieldIds) {
      const fd: any = this.allFields.find((f: any) => f.sid === fid);
      if (!fd) continue;
      if (fd.f_maxL) total += fd.f_maxL * 4;
      else if (fd.f_type) total += this.datatypeSize[fd.f_type.toLowerCase()] || 0;
      if (total > 3072) break;
    }
    return total;
  }

  private primaryIndexConflicts(fieldIds: string[], indexName: string): string | null {
    if (fieldIds.some((fid) => this.fieldIdMap[fid]?.toLowerCase() === 'id')) {
      return 'The Field Id cannot be set as primary key.';
    }
    if (this.rwfStatusField && fieldIds.includes(this.rwfStatusField)) {
      return this.translate
        .instant('DROPDOWN_WORKFLOW_STATUS_PRIMARY_MSG')
        .replace('{workflowStatusField}', this.fieldIdMap[this.rwfStatusField]);
    }
    return null;
  }

  private findDuplicateByName(existing: any[], name: string, currentSid?: string) {
    return existing.find(
      (e) => e.indexName?.toLowerCase() === name.toLowerCase() && (!currentSid || e.sid !== currentSid)
    );
  }

  private findDuplicateByFields(existing: any[], fieldIds: string[], currentSid?: string) {
    return existing.find(
      (e) =>
        (!currentSid || e.sid !== currentSid) &&
        Array.isArray(e.fields) &&
        e.fields.length === fieldIds.length &&
        e.fields.every((f) => fieldIds.includes(f))
    );
  }

  private getActionType(
    newType: string,
    prevFields: string[],
    newFields: string[],
    prevType: string,
    prevName: string,
    newName: string
  ): any {
    if (newType === IndexType.KEY && prevType !== IndexType.KEY) {
      return ActionType.INDEX_UPDATE_TO_SECONDARY;
    }
    const removed = prevFields.filter((f) => !newFields.includes(f));
    const added = newFields.filter((f) => !prevFields.includes(f));
    // Check if order has changed (same fields but different order)
    const orderChanged =
      prevFields.length === newFields.length &&
      prevFields.every((f) => newFields.includes(f)) &&
      !prevFields.every((f, index) => f === newFields[index]);
    if (removed.length || added.length || newType !== prevType || orderChanged) {
      return ActionType.INDEX_UPDATE;
    }
    if (newName !== prevName) {
      return ActionType.INDEX_RENAME;
    }
    return null;
  }

  private async fetchRuntimeOverridesIfPrimary(isPrimary: boolean, fieldIds: string[]): Promise<any[]> {
    if (!isPrimary) return [];
    return this.getRuntimeConfigOverrideValueFieldReference(fieldIds);
  }

  private showValidationError(message: string, formField?: string, errorType?: string): void {
    this.util.showError(message);
    if (formField && errorType) {
      this.formGroup.get(formField)?.setErrors({ [errorType]: true });
    }
    this.isLoading = false;
  }

  private validateIndexName(indexName: string): string | null {
    if (indexName.toLowerCase() === 'id') {
      return this.translate.instant('INDEX_ID');
    }
    if (this.formGroup.get('indexName')?.hasError('pattern')) {
      return this.translate.instant('INVALID_INDEXNAME');
    }
    const lowerName = indexName.toLowerCase();
    if (this.util.getRestrictedKeywords().includes(lowerName) || this.util.getRestrictedSQLKeywords().includes(lowerName)) {
      return this.translate.instant('KEYWORD_INDEXNAME');
    }
    if (this.pickList?.primaryFields?.some((f) => this.trimName(f.name) === this.trimName(indexName))) {
      return this.translate.instant('FIELD_AS_INDEXNAME');
    }
    return null;
  }

  private validateFieldConstraints(fieldIds: string[]): string | null {
    if (fieldIds.some((fid) => this.transientSids.includes(fid))) {
      return this.translate.instant('TRANSIENT_FIELD_AS_INDEX');
    }
    if (this.calcIndexLength(fieldIds) > 3072) {
      return this.translate.instant('MAX_LEN_INDEX');
    }
    return null;
  }

  private validateDuplicates(
    existing: any[],
    indexType: string,
    indexName: string,
    fieldIds: string[],
    currentSid?: string
  ): { message: string; field?: string; errorType?: string } | null {
    if (indexType === IndexType.PRIMARY) {
      const existingPrimary = existing.find((e) => e.indexType === IndexType.PRIMARY);
      if (existingPrimary && existingPrimary.sid !== currentSid) {
        return { message: this.translate.instant('NO_DUPLICATE_PRIMARY_KEY'), field: 'indexType', errorType: 'duplicate' };
      }
    }
    if (this.findDuplicateByName(existing, indexName, currentSid)) {
      return { message: this.translate.instant('NO_DUPLICATE_INDEX_NAMES'), field: 'indexName', errorType: 'duplicate' };
    }
    if (this.findDuplicateByFields(existing, fieldIds, currentSid) && indexType !== IndexType.KEY) {
      return { message: this.translate.instant('NO_DUPLICATE_INDEX_FIDS'), field: 'fields', errorType: 'duplicate' };
    }
    return null;
  }

  private haveFieldsChanged(prevFields: string[], newFields: string[]): boolean {
    const removed = prevFields.filter((f) => !newFields.includes(f));
    const added = newFields.filter((f) => !prevFields.includes(f));
    const orderChanged =
      prevFields.length === newFields.length &&
      prevFields.every((f) => newFields.includes(f)) &&
      !prevFields.every((f, index) => f === newFields[index]);
    return removed.length > 0 || added.length > 0 || orderChanged;
  }

  private getPreviousFields(): string[] {
    return Array.isArray(this.indexFormData?.fields)
      ? this.indexFormData.fields
      : (this.indexFormData?.fields || '').toString().split(',').filter((f) => !!f);
  }

  private updateWorkingIndices(existing: any[], newIndexObj: any, currentSid?: string): any[] {
    const working = [...existing];
    if (!currentSid) {
      working.push(newIndexObj);
    } else {
      const idx = working.findIndex((e) => e.sid === currentSid);
      if (idx > -1) working[idx] = newIndexObj;
    }
    return working;
  }

  private handleIndexUpdateFlow(working: any[], newIndexObj: any, fieldIds: string[], prevFields: string[], indexType: string, rawIndexName: string): void {
    const actionType = this.getActionType(
      indexType,
      prevFields,
      fieldIds,
      this.indexFormData?.indexType,
      this.indexFormData?.indexName,
      rawIndexName
    );

    const hasFieldsChanged = this.haveFieldsChanged(prevFields, fieldIds);
    const indexTypeChangedToKey = newIndexObj?.indexType === IndexType.KEY && this.indexFormData?.indexType !== IndexType.KEY;
    const shouldShowReferences = hasFieldsChanged || indexTypeChangedToKey;

    if (shouldShowReferences) {
      const referenceReq = {
        modelId: newIndexObj.sid,
        modelType: ModelType.INDEX_DEFINITION,
        actionType,
        action: UiActions.UPDATE
      };
      this.referenceUtil.handleWithReferences({
        payload: referenceReq,
        node: { name: newIndexObj.indexName, type: 'Indexes' },
        onConfirm: () => this.updateIndex(working, { ...newIndexObj, fields: [...fieldIds] }),
        onNoReferences: () => this.updateIndex(working, { ...newIndexObj, fields: [...fieldIds] }),
        onCancel: () => { this.isLoading = false; },
        onError: () => this.updateIndex(working, { ...newIndexObj, fields: [...fieldIds] })
      });
    } else if (actionType === null) {
      this.onCloseDesigner();
    } else {
      this.updateIndex(working, { ...newIndexObj, fields: [...fieldIds] });
    }
  }

  async saveIndex() {
    // Prevent duplicate saves if already loading
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    // Timeout is required because vb-pickup-list component's onChange event is called after 1000 ms debounce.
    setTimeout(() => {
      this.store.dispatch(setError({ error: null }));
      this.submitted = true;

      const raw = this.formGroup.getRawValue();
      const indexType = raw.indexType;
      const indexName = this.normalizeIndexName(raw.indexName || '');
      const fieldIds = this.normalizeFieldIds(raw.fields || '');

      this.formGroup.get('indexName')?.patchValue(indexName, { emitEvent: false });
      this.formGroup.get('fields')?.patchValue(fieldIds.join(','), { emitEvent: false });

      // Core mandatory checks
      if (!indexName || !indexType || fieldIds.length === 0) {
        return this.showValidationError(this.translate.instant('MANDATORY_FIELDS'));
      }

      // Validate index name
      const nameError = this.validateIndexName(indexName);
      if (nameError) return this.showValidationError(nameError);

      // Validate field constraints
      const fieldError = this.validateFieldConstraints(fieldIds);
      if (fieldError) return this.showValidationError(fieldError);

      // Primary specific conflicts
      if (indexType === IndexType.PRIMARY) {
        const primaryConflict = this.primaryIndexConflicts(fieldIds, indexName);
        if (primaryConflict) return this.showValidationError(primaryConflict);
      }

      // Duplicate validations
      const existing = Array.isArray(this.indices) ? [...this.indices] : [];
      const currentSid = this.indexFormData?.sid;
      const duplicateError = this.validateDuplicates(existing, indexType, indexName, fieldIds, currentSid);
      if (duplicateError) return this.showValidationError(duplicateError.message, duplicateError.field, duplicateError.errorType);

      // Assemble index object
      const newIndexObj: any = {
        sid: currentSid || uuidv4(),
        indexName,
        indexType,
        fields: fieldIds,
        appId: this.appId,
        orgId: this.orgId,
        tableId: this.formData.sid
      };

      const working = this.updateWorkingIndices(existing, newIndexObj, currentSid);

      // Handle create vs update flow
      if (!this.indexFormData) {
        this.updateIndex(working, { ...newIndexObj, fields: [...fieldIds] });
        return;
      }

      const prevFields = this.getPreviousFields();
      this.handleIndexUpdateFlow(working, newIndexObj, fieldIds, prevFields, indexType, raw.indexName);
    }, 1000);
  }

  getRuntimeConfigOverrideValueFieldReference(fields: string[]): Promise<any[]> {
    this.isLoading = true;

    const referencePromises: Promise<any>[] = [];

    fields.forEach((field) => {
      if (field) {
        referencePromises.push(
          this.referenceUtil.getReferences({
            modelId: field,
            modelType: ModelType.RUNTIME_CONFIGURATION,
            actionType: ActionType.RUNTIME_VALUE_OVERRIDE_FIELD_REMOVE,
            action: UiActions.UPDATE
          })
        );
      }
    });

    return new Promise((resolve, reject) => {
      Promise.all(referencePromises)
        .then((referenceResponse: any[]) => {
          this.isLoading = false;
          let refs: any = [];
          referenceResponse.forEach((references) => {
            refs = [...refs, ...references.filter((ref) => ref.propertyName === 'RUNTIME_WORKFLOW_VALUE_OVERRIDE')];
          });
          resolve(refs);
        })
        .catch((error) => {
          this.isLoading = false;
          reject([]);
        });
    });
  }

  showRuntimeOverrideValueChangeConfirmation(data, indexObj) {
    const confirmationObj = {
      message: `${this.translate.instant('PRIMARY_INDEX_UPDATE_RUNTIME_VALUE_OVERRIDE_REMOVAL_MSG')} ${this.translate.instant('UPDATE_CONF_MSG')}`,
      header: this.translate.instant('CONFIRMATION'),
      accept: () => {
        this.updateIndex(data, indexObj);
      },
      reject: () => {
        return;
      }
    };
    this.confirmationDialogService.confirm(confirmationObj);
  }

  updateIndex(data, indexObj) {
    this.store.dispatch(setIndex({ savedIndex: null }));
    this.store.dispatch(setError({ error: null }));
    try {
      this.formFields.markAsDirty();
      let apiConstants = this.indexFormData ? { ...ApiConstants.updateIndex } : { ...ApiConstants.saveIndex };
      if (typeof indexObj.fields == 'string') indexObj.fields = indexObj.fields.split(',');
      this.isLoading = true;
      this.store.dispatch(saveIndex({ apiConstants, indexObject: JSON.stringify(indexObj) }));
    } catch (e) {
      this.isLoading = false;
      console.error(e);
    }
  }

  getFieldNames(fields) {
    if (!fields) {
      return '';
    }
    const fieldNames: any = [];
    let fieldIds = fields;
    if (typeof fields === 'string') {
      fieldIds = fields.split(',');
    }
    fieldIds.forEach((e) => {
      fieldNames.push(this.fieldIdMap[e]);
    });
    return fieldNames.join(', ');
  }

  removeIndex(data: any) {
    this.store.dispatch(deleteSuccess({ deleteIndexId: null }));
    this.store.dispatch(deleteError({ deleteError: null }));
    this.isLoading = true;
    const indexObj = {
      modelId: data.sid,
      modelType: ModelType.INDEX_DEFINITION,
      actionType: ActionType.INDEX_DELETE,
      action: UiActions.DELETE
    };
    this.referenceUtil.handleWithReferences({
      payload: indexObj,
      node: { name: data.indexName, type: 'Indexes' },
      onConfirm: () => {
        this.confirmDeletion(data.sid, data.indexName, {}, true);
      },
      onNoReferences: () => {
        this.confirmDeletion(data.sid, data.indexName, {});
      },
      onCancel: () => {
        this.isLoading = false;
      },
      onError: () => {
        this.confirmDeletion(data.sid, data.indexName, {});
      }
    });
  }

  confirmDeletion(sid, fkName, value?: any, fromReferencePopup?: boolean) {
    this.isLoading = false;
    const message = this.formConfirmationMessage(fkName, value);
    if (!fromReferencePopup) {
      const confirmationObj = {
        message,
        header: this.translate.instant('CONFIRMATION'),
        accept: () => {
          this.confirmDelIndex(sid);
        },
        reject: () => {
          return;
        }
      };
      this.zone.run(() => {
        this.confirmationDialogService.confirm(confirmationObj);
      });
    } else {
      this.confirmDelIndex(sid);
    }
  }

  confirmDelIndex(sid) {
    this.isLoading = true;
    const params = {
      tableId: this.formData.sid,
      indexId: sid,
      appId: this.appId,
      orgId: this.orgId
    };
    this.store.dispatch(deleteIndex({ apiConstants: { ...ApiConstants.deleteIndex }, params }));
  }

  formConfirmationMessage(name, value) {
    let message = '';
    let keys = Object.keys(value);
    let keysLength = keys.length;
    message += this.translate.instant('INDEX_DELETION_CONFIRMATION', { indexName: name });
    return message;
  }

  showWhereUsed(column: any): void {
    this.isLoading = true;
    this.referenceUtil.showWhereUsed(
      {
        id: column.sid,
        name: column.indexName,
        type: this.translate.instant('INDEX')
      },
      { hideLoader: () => (this.isLoading = false) }
    );
  }

  getDataFromFS() {
    const version = this.appGlobalService.get('appVersion');
    const queryObject = {
      collectionName: `TableIndex_${version}`,
      filter: [
        {
          field: 'appId',
          operator: '==',
          value: this.appId
        },
        {
          field: 'tableId',
          operator: '==',
          value: this.formData.sid
        }
      ]
    };
    this.isLoading = true;
    this.getIndexData(queryObject);
  }

  getIndexData(queryObject: any) {
    try {
      if (this.fsDataSub && typeof this.fsDataSub.unsubscribe === 'function') {
        this.fsDataSub.unsubscribe();
      }

      this.fsDataSub = this.fsService.fireService(queryObject).subscribe(
        (res: any) => {
          if (res && res.length > 0) {
            let data = [];

            const extractIndexFields = (d: any) => ({
              sid: d.sid,
              indexName: d.indexName,
              fields: d.fields,
              indexType: d.indexType,
              appId: d.appId,
              tableId: d.tableId,
              orgId: d.orgId || this.orgId
            });

            if (this.initialCall) {
              this.initialCall = false;
              const filteredRes =
                res?.filter((dt) => !dt.payload.doc.metadata.fromCache && !dt.payload.doc.data().recDeleted) || [];
              data = filteredRes.map((obj) => extractIndexFields(obj.payload.doc.data()));
              this.indices = data;
            } else {
              // Create a working copy to avoid mutation during iteration
              let updatedIndices = [...this.indices];
              let hasChanges = false;
              res.forEach((dt) => {
                const docData = dt.payload.doc.data();
                const sid = docData.sid;
                const index = updatedIndices.findIndex((idx) => idx.sid === sid);

                if (docData.recDeleted) {
                  // Remove from indices if recDeleted is true
                  if (index !== -1) {
                    updatedIndices.splice(index, 1);
                    hasChanges = true;
                  }
                } else if (dt.payload.doc.exists || dt.type === 'added' || dt.type === 'modified') {
                  // Add or update index in indices
                  const newIndex = extractIndexFields(docData);
                  if (index !== -1) {
                    // Update existing index
                    updatedIndices[index] = { ...updatedIndices[index], ...newIndex };
                    hasChanges = true;
                  } else {
                    // Add new index
                    updatedIndices.push(newIndex);
                    hasChanges = true;
                  }
                }
              });

              // Only update if there were actual changes
              if (hasChanges) {
                this.indices = updatedIndices;
              }
            }
            this.store.dispatch(setAllIndices({ indexObjects: this.indices }));
          }
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          console.error(error);
        }
      );
      this.subscriptions.push(this.fsDataSub);
    } catch (e) {
      this.isLoading = false;
      console.log(e);
    }
  }

  unsubscribeListener() {
    this.subscriptions.forEach((k) => {
      if (k && typeof k.unsubscribe == 'function') {
        k.unsubscribe();
      }
    });
  }
}


